<div class="unique-header">
    <owc-icon name="circle_clear" family="" (click)="oncancelNotification()" class="header-close-icon"></owc-icon>
    <span class="header-title">Create local notification</span>
</div>

<div class="unique-horizontal-stepper">
    <owc-stepper #stepper [linear]="isLinear" class="unique-mat-stepper">
        <ng-template let-index="index" matStepperIcon="done">
            <span [ngSwitch]="isLinear">
                <owc-icon *ngSwitchCase="true">yes</owc-icon>
                <span *ngSwitchCase="false"></span>
            </span>
        </ng-template>
        <ng-template let-index="index" matStepperIcon="number"> </ng-template>
        <ng-template let-index="index" matStepperIcon="edit"> </ng-template>
        <owc-step *ngFor="let step of stepperConfig">
            <owc-card oneCard one-flat-card *ngTemplateOutlet="step.template"></owc-card>
        </owc-step>
    </owc-stepper>

    <ng-container *ngIf="!showCreateLocalSection">
        <h3 class="unique-mat-heading">Create local notification ID</h3>
        <p>Choose the countries and notification type for local notification.</p>
        
        <div class="unique-horizontal-stepper-dropdown-row">
            <owc-select-dropdown [formControl]="countriesFormControlOutlinedSmall" [placeholder]="'Choose countries'"
                variant="outlined" size="big" class="unique-horizontal-stepper-countries-list" (valueChange)="onCountryValueChange($event)">
                <owc-list-item *ngFor="let item of countriesList" [value]="item.label">
                    {{ item.label }}</owc-list-item>
            </owc-select-dropdown>
            
            <owc-select-dropdown [formControl]="notificationTypeFormControl" [placeholder]="'Notification type'"
                variant="outlined" size="big" class="unique-horizontal-stepper-countries-list" (valueChange)="onNotificationTypeValueChange($event)">
                <owc-list-item *ngFor="let item of notificationTypeList" [value]="item.label">
                    {{ item.label }}</owc-list-item>
            </owc-select-dropdown>
        </div>

        <div class="uniqueid-dialog-content">
            <p>Choose if your local notification is based on a global notification:</p>
            <owc-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                [formControl]="localBasedGlobalNotificationRadioButton" style="margin-bottom: 24px;">
                <div (click)="onRadioClick('local')" style="cursor: pointer;">
                    <owc-radio value="local" class="example-radio-button">
                        This local notification is not based on a global notification.
                    </owc-radio>
                </div>

                <div (click)="onRadioClick('global')" style="cursor: pointer;">
                    <owc-radio value="global" class="example-radio-button">
                        This local notification is based on a global notification.
                    </owc-radio>
                </div>
            </owc-radio-group>

            <div *ngIf="selectedRadioValue === 'local'"
                class="unique-horizontal-stepper-local-Id" style="display: inline-flex;">
                <label class="unique-horizontal-stepper-local-Id-label">Define a local notification ID:</label>

                <owc-input [label]="'Local Notification ID'" [formControl]="localIDformctrl" min="1"
                    placeholder="Local Notification ID e.g. QN-CPS-2020-001" style="width: 100%;"
                    (input)="onLocalIdInput($event)" (keyup)="onLocalIdInput($event)" (change)="onLocalIdInput($event)" (valueChange)="onLocalIdInput($event)"></owc-input>
            </div>
            <div class="unique-horizontal-stepper-local-container"
                *ngIf="selectedRadioValue === 'global'" style="display: inline-flex;">
                <owc-input placeholder="Global notification ID e.g. QN-CPS-2020-001"
                    [formControl]="searchNotificationId">
                    <owc-icon slot="prefix" name="search" family="outlined" />
                </owc-input>
                <owc-button [disabled]="isDisabledSearch" (click)="onSerach()">
                    Search
                </owc-button>
            </div>
        </div>
    </ng-container>

    <div class="mat-elevation-z8" [ngStyle]="{ display: isTableShow && !showCreateLocalSection ? 'block' : 'none' }">
        <div class="unique-horizontal-stepper-table">
            <span>Global notification search results for {{notificationTypeFormControl.value?.['label'] || 'selected'}}
                notification type</span>
            <span *ngIf="dataFlag">{{ dataSource.length }} results</span>
            <span *ngIf="!dataFlag">0 results</span>
        </div>
        <owc-table class="cn-recepients-table" disabled="isTableShow" *ngIf="dataFlag && dataSource.length > 0">

            <!-- Table Header -->
            <owc-table-header sticky
                style="z-index:1; border-bottom: none !important; box-shadow: none !important;">
                <owc-table-header-cell>
                    Document title
                </owc-table-header-cell>
                <owc-table-header-cell>
                    Version
                </owc-table-header-cell>
                <owc-table-header-cell>
                    Language
                </owc-table-header-cell>
                <owc-table-header-cell>
                    Date
                </owc-table-header-cell>
                <owc-table-header-cell></owc-table-header-cell>
            </owc-table-header>

            <!-- Table Body -->
            <owc-table-body>
                    @for (element of getPaginatedData(); track $index) {
                <owc-table-row>

                    <owc-table-simple-cell >
                        <div class="truncate-text">{{ element.Title }}</div>
                    </owc-table-simple-cell>

                    <owc-table-simple-cell >
                        <div class="truncate-text">{{ element.VersionNumber }}</div>
                    </owc-table-simple-cell>

                    <owc-table-simple-cell>
                        
                        <div class="truncate-text">{{ element.Language[0]?.IsoCode | uppercase }}</div>
                    </owc-table-simple-cell>

                    <owc-table-simple-cell>
                        <div class="truncate-text">{{ element.ModifyDate | date: 'dd/MM/yyyy' }}</div>
                    </owc-table-simple-cell>

                    <!-- Edit icon -->
                    <owc-table-simple-cell style="cursor: pointer;" (click)="onSelectNotification(element)">
                        <owc-icon name="sign_plus" family="outlined"></owc-icon>
                    </owc-table-simple-cell>

                </owc-table-row>
            }
            </owc-table-body>
        </owc-table>

            <!-- No data found table -->
            <table style="width:100%" *ngIf="!dataFlag"
            class="no-data-found-table mat-table cdk-table ng-star-inserted">
            <tr class="mat-header-row cdk-header-row ng-star-inserted">
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Document title</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Version</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Language</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Date</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                </th>
            </tr>
            <tr class="mat-header-row cdk-header-row ng-star-inserted" style="padding-left: 24 px; height: 254px;">
                <td colspan="5" style="align-items: center; justify-content: space-around; text-align: center;">
                    <p style="width: 26%; margin: auto;">
                        No document found for this search text and document type.
                    </p>
                </td>
            </tr>
        </table>

        <!-- Search error table -->
        <table style="width:100%" *ngIf="dataFlag && dataSource.length == 0"
            class="no-data-found-table mat-table cdk-table ng-star-inserted">
            <tr class="mat-header-row cdk-header-row ng-star-inserted">
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Document title</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Version</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Language</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                    Date</th>
                <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">
                </th>
            </tr>
            <tr class="mat-header-row cdk-header-row ng-star-inserted" style="padding-left: 24 px; height: 254px;">
                <td colspan="5" style="align-items: center; justify-content: space-around; text-align: center;">
                    <owc-icon svgIcon="no_data_found"
                        style="height: 82px;width:82px;padding-bottom: 24px;"></owc-icon>
                    <span style="padding-bottom: 8px;display: block;"> <B>Search error</B> </span>
                    <p style="width: 26%; margin: auto;">
                        There was an error while running your search. Please try again.
                    </p>
                </td>
            </tr>
        </table>

        <!-- Custom Pagination -->
        <div class="custom-pagination">
            <div class="pagination-left">
                <label>Items per page:</label>
                <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="page-size-select">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="20">20</option>
                    <option [value]="50">50</option>
                </select>
            </div>
            
            <div class="pagination-info">
                <ng-container *ngIf="totalItems > 0">
                    {{ getStartIndex() + 1 }}-{{ getEndIndex() }} of {{ totalItems }}
                </ng-container>
                <ng-container *ngIf="totalItems === 0">
                    0 of 0
                </ng-container>
            </div>
            
            <div class="pagination-controls">
                
                    <owc-icon class="pagination-btn" (click)="goToFirstPage()" [disabled]="totalItems === 0 || currentPage === 1" name="chevron_left" family="outlined"></owc-icon>
                
                
                    <owc-icon class="pagination-btn" (click)="goToPreviousPage()" [disabled]="totalItems === 0 || currentPage === 1" name="chevron_left" family="outlined"></owc-icon>
                
                
                    <owc-icon class="pagination-btn" (click)="goToNextPage()" [disabled]="totalItems === 0 || currentPage >= totalPages" name="chevron_right" family="outlined"></owc-icon>
                
                    <owc-icon class="pagination-btn" name="chevron_right" family="outlined"  (click)="goToLastPage()" [disabled]="totalItems === 0 || currentPage >= totalPages"></owc-icon>
                
            </div>
        </div>
    </div>

    <ng-container *ngIf="showCreateLocalSection" style="padding: 0 24px 24px 24px;">
        <div style="display: flex; align-items: center; margin-bottom: 24px;">
            <h1 style="margin: 0; font-size: 24px; font-weight: 600; color: #1a1a1a;">Create local notification</h1>
        </div>
        <div class="globalid-dialog-content">
            <p style="margin-bottom: 24px; color: #666; font-size: 14px;">To create the local notification ID, define a suffix to the global notification ID:</p>
            
            <div class="input-combination-container">
                <div class="input-wrapper">
                    <owc-input [label]="'Global notification ID'" value="{{ uniqueID }}" [disabled]="true">
                    </owc-input>
                </div>
                
                <span class="plus-icon">+</span>
                
                <div class="input-wrapper">
                    <owc-input [label]="'Suffix'" [formControl]="globalIDformctrl" (input)="onGlobalIdInput($event)" (keyup)="onGlobalIdInput($event)" (change)="onGlobalIdInput($event)" (valueChange)="onGlobalIdInput($event)"></owc-input>
                </div>
            </div>
            
            <p>Local notification ID:<span name="globalID" class="text-id" [innerHTML]="globalID"></span>{{ globalIDformctrl.value }}</p>
        </div>
    </ng-container>

</div>

<div class="unique-footer">
    <owc-button type="button"  class="btn secondary" (click)="oncancelNotification()">
        Cancel
    </owc-button>
    <owc-button color="primary" [disabled]="isCreateDisabled" (click)="createLocalGlobalId()" type="submit">
        Create
    </owc-button>
</div>
    